<div class="flex flex-col h-full md:m-0 card-border bg-white rounded-md" (click)="articleRoute()">
  <div class="w-full entry-listing-image h-48">
    @if (image && image.url) {
      <img
        class="h-48 object-cover entry-listing-image rounded-t-md"
        src="{{ imgixService.buildImgixUrl(image.url) }}"
        [alt]="image.altText ? image.altText : ''"
        width="800"
        height="500"
        />
    }
  </div>
  <div class="content-card w-full top-3/4 z-10 rounded h-full py-v-spacing px-v-spacing">
    @if (relatedResourceContent) {
      <div class="mx-auto flex flex-col justify-between h-full">
        <span class="text-xs text-vis-subtle">{{ dateCreated }}</span>
        <span class="eyebrow text-vis-subtle">{{ relatedResourcesCategory }}</span>
        <div class="wysiwyg mb-v-spacing" [innerHTML]="relatedResourceContent"></div>
        <div class="mt-auto">
          @if (relatedResourceLink) {
            <vision-button defaultStyle="tertiary" [data]="ctaButtonData"></vision-button>
          }
        </div>
      </div>
    }
  </div>
</div>
